export namespace FolderUtils {
  export type FileTreeEntry = { file: unknown; fileEntry: unknown; path: string };

  export const arrangeIntoTree = (fileTree: FileTreeEntry[]) => {
    let result = [];
    let level = { result };
    fileTree.forEach((tree) => {
      if (!tree.path || typeof tree.path !== 'string') {
        console.error('Invalid path:', JSON.stringify(tree));
        return;
      }

      tree.path.split('/').reduce((r, name, i, a) => {
        if (!r[name]) {
          r[name] = { result: [] };
          let completePath = a.join('/');
          r.result.push({ name, children: r[name].result, path: completePath });
        }

        return r[name];
      }, level);
    });

    return result;
  };
}
